module.exports = __webpack_public_path__ + "housingStatic/img/basic_chuzu.6712e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/basic/basic_chuzu.png
// module id = xxWO
// module chunks = 2